import { useEffect } from 'react';
import { trackAbTestV2Variant } from 'dibs-ab-tests/src/clientAbTestV2';
import { PDP_TOP_YMAL_SPONSORED_TEST } from '../../utils/abTestHelper';

export const usePdpTopYmalSponsoredTestTracking = (): void => {
    useEffect(() => {
        trackAbTestV2Variant(PDP_TOP_YMAL_SPONSORED_TEST);
    }, []);
};
